// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"c54af199","151":"4d382b46","206":"0ad6a5a0","453":"f09043d9","472":"35ecdc2f","508":"4df9e1f7","565":"74bdd709","615":"ec9f0a25","658":"04dd99b8","754":"cab78be8"}[chunkId] + ".chunk.js";
};